<template>
  <div class="flex space-x-4 md:space-x-6">
    <span
      class="grid size-8 shrink-0 place-items-center rounded-full border-2 bg-white text-sm font-bold text-supplement md:size-10"
    >{{ number }}</span>
    <div class="w-full min-w-0">
      <p class="mt-1 md:mt-2">
        <strong class="text-lg leading-tight">{{ title }}</strong><br />{{ description }}
      </p>

      <div class="mt-3">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  number: number
  title: string
  description: string
}>()
</script>
